module.exports = __webpack_public_path__ + "static/media/logos_video_en.41d24e15.png";